const Chevron = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 8 16' fill='none'>
			<path
				d='M7 8C7 8.08756 6.98364 8.17051 6.95092 8.24885C6.92229 8.32258 6.87935 8.39171 6.82209 8.45622L1.96319 13.8134C1.85276 13.9378 1.71779 14 1.55828 14C1.45603 14 1.36196 13.9724 1.27607 13.9171C1.19018 13.8618 1.1227 13.7857 1.07362 13.6889C1.02454 13.5968 1 13.4908 1 13.371C1 13.2005 1.05317 13.0507 1.15951 12.9217L5.62577 8L1.15951 3.07834C1.05317 2.94931 1 2.79954 1 2.62903C1 2.50922 1.02454 2.40323 1.07362 2.31106C1.1227 2.21429 1.19018 2.13825 1.27607 2.08295C1.36196 2.02765 1.45603 2 1.55828 2C1.71779 2 1.85276 2.05991 1.96319 2.17972L6.82209 7.54378C6.87935 7.60829 6.92229 7.67972 6.95092 7.75806C6.98364 7.8318 7 7.91244 7 8Z'
				fill='#627182'
				fillOpacity='0.3'
			/>
		</svg>
	);
};

export default Chevron;
